import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography, useMediaQuery,useTheme
} from '@mui/material'
import Parser from 'html-react-parser';

// import {
//     AppUI,
//     FingerSDK,
//     SdkOptionsType,
//     TransactionMode,
// } from "@identy/identy-finger";
// import "@identy/identy-finger/dist/identy-finger-style.css";

import axios from 'axios'

//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './IdentityValidationStyles'

import { fileActions } from '../../store/actions'
import { CustomLoadingOverlay ,Buttons ,GenericContainer} from '../../components'
import { environment, HandType, TransacMode ,coreFunctions} from '../../utils'
import { useTranslation } from 'react-i18next';

export default function FingersCaptureComponent(props) {
    const matches = useMediaQuery('(min-width:650px)');
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const gridContainer = {} //mainStyles.gridStyle()

    const [folioId, setFolioId] = useState('')
    const [loadView, setLoadView] = useState(false)
    const { t } = useTranslation();

    const [capturedCurrentFinger, setCapturedCurrentFinger] = useState("")
    const [isRunning, setIsRunning] = useState(false)
    const [username, setUsername] = useState(false)
    const [capturedCurrentHand, setCapturedCurrentHand] = useState("")

    // const [id, setId] = useState("")
    const [action, setAction] = useState("")
    // const [id, setId] = useState("")
    // const [callbackURL, setCallbackURL] = useState("")

    // const [pdx, setPdx] = useState(null)
    // const [ctx, setCtx] = useState(null)

    const file = useSelector(state => state.FileInfo)
    const dispatch = useDispatch()

    useEffect(() => {
        // dispatch(fileActions.GetFileInfo(location.state.folioId))
        setFolioId(location.state.folioId)
        setCapturedCurrentFinger(location.state.capturedFingerCurrent)
        setCapturedCurrentHand(location.state.capturedHandCurrent)
        console.log("capturedFingerCurrent------------------------------: ", location.state.capturedFingerCurrent)
        console.log("capturedHandCurrent------------------------------: ", location.state.capturedHandCurrent)
        console.log("File_ID-------------------------------: ", location.state.folioId)
        console.log("window.location.origin.includes-------------------------------------; ", window.location.origin.includes("localhost"))
        setUsername(window.location.origin.includes("localhost") ? "localhost" : null)
    }, [])

    let handleCapture = () => {
        alert("Capturado")
        let nextComponent = null
        if (capturedCurrentHand != undefined) {
            nextComponent = 'HelpHandsComponent'
            let capturedHand = 1
            coreFunctions.DoNextStage({ navigate, nextComponent, State: {folioId, capturedHand} })

        } else {
            nextComponent = 'HelpFingertComponent'
            let capturedFinger = 1
            coreFunctions.DoNextStage({ navigate, nextComponent, State: {folioId, capturedFinger} })

        }

        // TODO: si se captura la minucia izquieda se continua el flujo
        // capturedCurrentFinger  debe estar en "RIGHT"
    }

    return (
        <GenericContainer>
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                <div className={localStyles.centerContentDialog}>
                    {capturedCurrentFinger &&
                        <Typography variant="h6"
                            gutterBottom> <b>{capturedCurrentFinger === HandType.LEFT ? 'Buscando índice izquierdo' : 'Buscando índice derecho'}</b></Typography>
                    }
                    {capturedCurrentHand &&
                        <Typography variant="h6"
                            gutterBottom> <b>{capturedCurrentHand === HandType.LEFT ? 'Buscando mano izquierda' : 'Buscando mano derecha'}</b></Typography>
                    }
                    </div>
                    {/* implementar lo de Identy */}
                    <Buttons
                        ConfirmButtonText={t("document_capture")}
                        onClickConfirm={handleCapture}                    />

        </GenericContainer>
    )
}